import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Row, Col } from 'react-bootstrap'

import { S3_PREFIX } from '@shared-submodule/sm-constants'
import playerImg from '@assets/images/placeholder/playerPagePlaceholder.svg'
import styles from './style.module.scss'
const CustomLink = dynamic(() => import('@shared/components/customLink'))
const MyImage = dynamic(() => import('@shared/components/myImage'))

const SeriesStatsTabData = ({ selectedStat, mostRunsData, bestStrikeData, bowlingMostWicketsData, bestEconomyRateData }) => {
  return (
    <section className="mb-3">
      {selectedStat === 'Most Runs' && (
        <Row className={`${styles.root} mx-0 flex-nowrap scroll-list`}>
          {mostRunsData?.slice(0, 5)?.map((ele, index) => {
            return (
              <Col className={styles.playerContainer} key={ele._id}>
                <div className={`${styles.playerCard}`}>
                  <CustomLink href={`/${ele?.oPlayer?.oSeo?.sSlug}`} prefetch={false}>
                    <a className={`${styles.imgBlock} d-block m-auto ${ele?.oPlayer?.eTagStatus === 'a' ? '' : 'disabled opacity-100'}`}>
                      <MyImage
                        src={ele?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${ele?.oPlayer?.oImg?.sUrl}` : playerImg}
                        width="162"
                        height="162"
                        alt={ele?.oPlayer?.oImg?.sText || 'Player Image'}
                        layout="responsive"
                      />
                    </a>
                  </CustomLink>
                  <div className={styles.crown}></div>
                  <h3 className="small-head mt-4">{ele?.oPlayer?.sFullName}</h3>
                  <p>{ele?.oTeam?.sAbbr}</p>
                  <div className={styles.stat}>{ele?.nRuns || '0'}</div>
                </div>
              </Col>
            )
          })}
        </Row>
      )}
      {selectedStat === 'Best Strike Rate' && (
        <Row className={`${styles.root} mx-0 flex-nowrap scroll-list`}>
          {bestStrikeData?.slice(0, 5)?.map((ele, index) => {
            return (
              <Col className={styles.playerContainer} key={ele._id}>
                <div className={`${styles.playerCard}`}>
                  <CustomLink href={`/${ele?.oPlayer?.oSeo?.sSlug}`} prefetch={false}>
                    <a className={`${styles.imgBlock} d-block m-auto ${ele?.oPlayer?.eTagStatus === 'a' ? '' : 'disabled opacity-100'}`}>
                      <MyImage
                        src={ele?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${ele?.oPlayer?.oImg?.sUrl}` : playerImg}
                        width="162"
                        height="162"
                        alt={ele?.oPlayer?.oImg?.sText || 'Player Image'}
                        layout="responsive"
                      />
                    </a>
                  </CustomLink>
                  <div className={styles.crown}></div>
                  <h3 className="small-head mt-4">{ele?.oPlayer?.sFullName}</h3>
                  <p>{ele?.oTeam?.sAbbr}</p>
                  <div className={styles.stat}>{ele?.sStrike || '0'}</div>
                </div>
              </Col>
            )
          })}
        </Row>
      )}
      {selectedStat === 'Most Wickets' && (
        <Row className={`${styles.root} mx-0 flex-nowrap scroll-list`}>
          {bowlingMostWicketsData?.slice(0, 5)?.map((ele, index) => {
            return (
              <Col className={styles.playerContainer} key={ele._id}>
                <div className={`${styles.playerCard}`}>
                  <CustomLink href={`/${ele?.oPlayer?.oSeo?.sSlug}`} prefetch={false}>
                    <a className={`${styles.imgBlock} d-block m-auto ${ele?.oPlayer?.eTagStatus === 'a' ? '' : 'disabled opacity-100'}`}>
                      <MyImage
                        src={ele?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${ele?.oPlayer?.oImg?.sUrl}` : playerImg}
                        width="162"
                        height="162"
                        alt={ele?.oPlayer?.oImg?.sText || 'Player Image'}
                        layout="responsive"
                      />
                    </a>
                  </CustomLink>
                  <div className={styles.crown}></div>
                  <h3 className="small-head mt-4">{ele?.oPlayer?.sFullName}</h3>
                  <p>{ele?.oTeam?.sAbbr}</p>
                  <div className={styles.stat}>{ele?.nWickets || '0'}</div>
                </div>
              </Col>
            )
          })}
        </Row>
      )}
      {selectedStat === 'Best Economy Rates' && (
        <Row className={`${styles.root} mx-0 flex-nowrap scroll-list`}>
          {bestEconomyRateData?.slice(0, 5)?.map((ele, index) => {
            return (
              <Col className={styles.playerContainer} key={ele._id}>
                <div className={`${styles.playerCard}`}>
                  <CustomLink href={`/${ele?.oPlayer?.oSeo?.sSlug}`} prefetch={false}>
                    <a className={`${styles.imgBlock} d-block m-auto ${ele?.oPlayer?.eTagStatus === 'a' ? '' : 'disabled opacity-100'}`}>
                      <MyImage
                        src={ele?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${ele?.oPlayer?.oImg?.sUrl}` : playerImg}
                        width="162"
                        height="162"
                        alt={ele?.oPlayer?.oImg?.sText || 'Player Image'}
                        layout="responsive"
                      />
                    </a>
                  </CustomLink>
                  <div className={styles.crown}></div>
                  <h3 className="small-head mt-4">{ele?.oPlayer?.sFullName}</h3>
                  <p>{ele?.oTeam?.sAbbr}</p>
                  <div className={styles.stat}>{ele?.nEcon || '0'}</div>
                </div>
              </Col>
            )
          })}
        </Row>
      )}
    </section>
  )
}

SeriesStatsTabData.propTypes = {
  selectedStat: PropTypes.string,
  mostRunsData: PropTypes.array,
  bestStrikeData: PropTypes.array,
  bowlingMostWicketsData: PropTypes.array,
  bestEconomyRateData: PropTypes.array
}

export default SeriesStatsTabData
